import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import Card from './Card';

const CardList = ({ cards }) =>
  cards.map(({ image, imageAlt, url, eyebrowText, body, caption }, index) => (
    <Card
      key={index}
      url={url}
      bgColor="transparent-black"
      image={image}
      imageAlt={imageAlt}
      imageConstraint="300px"
      imagePosition="left"
      padding="35px"
      internalPadding="none"
      hover="light-grey"
      borderTopBottom={true}
      collapseBorder={true}
      eyebrowText={eyebrowText}
      titleStyle="thin"
      title={caption}
    >
      <p>{body}</p>
    </Card>
  ));

export default DisplayComponent(CardList);
